export const environment = {
  production: true,
  KEY_RAZORPAY: 'rzp_test_v5G5B8JAJLCJhO',
  BASE_URL : 'https://test.onelap.in/api/ecom',
  // BASE_URL : 'https://ecom.onelap.in:8443/OnelapinBackendSpring-0.0.1-SNAPSHOT',
  
  CONTROL_BASE_URL:'https://test.onelap.in/api/control',
  CONTROL_UI_URL: 'https://test.onelap.in/control/#',
  CONTROL_URL: 'https://test.onelap.in/control/#',
  UI_BASE_URL:'https://test.onelap.in',
  invoice:{
    GSTIN: '07AACCO9712A1ZR',
    CIN: 'U52334DL2019PTC351999',
    sold_by: 'Onelap Telematics Pvt. Ltd.',
    address: 'Second Floor, A67 Sector 2 Noida 201301',
    test:true,
    text_align_end:true
  },
  MAGIC_CHECKOUT_ENABLED: true,
  gmt:'0' ,   //mins,
  companyBankDetails: {
    bankName: "HDFC Bank",
    accountHolderName:"Onelap Telematics Pvt. Ltd.",
    accountNo:"50200053063178",
    IFSC: "HDFC0004400",
    upiId: "onelap.in@upi"
},
whatsApp:{
  isActive: true,
  link: 'https://api.whatsapp.com/send?phone=917217760961&text=Hii'
},
  video_links:{
    "ol_go":"https://www.youtube-nocookie.com/embed/q-dhtq9ou8w",
    "ol_micro":"https://www.youtube-nocookie.com/embed/lN3OlUuosmE",
    "ol_micro_plus":"https://www.youtube-nocookie.com/embed/lN3OlUuosmE",
    "ol_pocket":""
  },
  assets:{
    micro_video_thumbnail: "/assets/thumbnail/onelap-micro.jpg",
    go_video_thumbanail: "/assets/thumbnail/onelap-go.jpg",
},
lead: {
  skipOtp: true,
  pcClaimReward: '../../../../assets/svg/pc-claim-reward.png',
  mobileClaimReward: '../../../../assets/svg/mobile-claim-reward.webp'
},
showFestivalDeal:true,

isDeal : (new Date("Wed 10 March 2023 24:00:00 GMT-0700")) as any -Date.now()>0? true: false,
newProduct: {
    released: true,
    till : (new Date("Wed 10 March 2023 24:00:00 GMT-0700")) as any -Date.now()>0? true: false,
    end:"Fri 10 March 2023 24:00:00 GMT-0700"
},
Device: "85269190",  //device
hsnRelay: '8536', //relay
sac: '995469', //sub sim
hsnDevice: "85269190",  //device
host: "@test.onelap.in"
};
